<template>
  <div class="literature-detail">
    <Sbanner :detailInfo="detailOne" :showTitle="true" v-if="detailOne && detailOne.id" />

    <div class="container">
      <!-- 正文 -->
      <div class="news-detail">

        <loading v-if="showLoading" />

        <div class="news-detail-in" v-if="detailOne">

          <div class="news-title">
            {{ detailOne.title }}
            <div class="actionBox">
              <Actions v-if="detailOne.id" banner="6" :view="detailOne.browse_count" :collect="detailOne.collect_count"
                :like="detailOne.like_count" :row="detailOne" />
            </div>
          </div>
          <div class="flex jc" v-if="detailOne.award">
            <div class="news-honor">
              <div class="prize flex start" v-if="detailOne.activity_name || detailOne.award">
                <i class="iconfont2 icon2-trophy-fill" v-if="detailOne.award" />
                <template v-if="detailOne.activity_name">
                  <router-link target="_blank" :to="{ path: '/activity/' + detailOne.activity_id }"
                    v-if="detailOne.activity_id">
                    <div class="fonts">{{ detailOne.activity_name || '' }}</div>
                  </router-link>
                  <div class="fonts" v-else>{{ detailOne.activity_name }}</div>
                </template>
                <div class="fonts" :class="detailOne.activity_name && detailOne.award ? 'points' : ''"
                  v-if="detailOne.award">{{ detailOne.award }}</div>
              </div>
            </div>
          </div>
          <template v-if="detailOne.category == 2">
            <div class="news-pub" v-if="authorList && authorList.length">
              <div class="introduce" :ref="`intro_${index}`" v-for="(item, index) in authorList" :key="index">
                <div class="con" :class="item.showAll ? '' : 'hideMore'">
                  <span v-html="item.content"></span>
                  <div class="moreBtn" v-if="item.showBtn && !item.showAll" @click="onShowAll(item)">更多 <i class="iconfont icon-arrow-down" /></div>
                  <div class="moreBtn close" v-if="item.showBtn && item.showAll" @click="onShowAll(item)">收起 <i class="iconfont icon-arrow-up" /></div>
                </div>
              </div>
            </div>
          </template>
          <div class="news-pub" v-if="detailOne.author">
            <div class="con" v-html="detailOne.author"></div>
          </div>
          <div class="news-pub" v-if="detailOne.city || detailOne.county || detailOne.produce_time">
            <span v-if="detailOne.city || detailOne.county">{{ detailOne.city || '' }}{{ detailOne.county || '' }}</span>
            <span v-if="detailOne.produce_time">{{ detailOne.produce_time }}</span>
          </div>
          <div class="news-pub" v-if="detailOne.submitted_unit">
            <span>报送单位：{{ detailOne.submitted_unit || '' }}</span>
          </div>

          <div class="news-brief" v-if="detailOne.introduce" v-html="detailOne.introduce"> </div>

          <div :class="{ noRightFilter: noRight }">
            <NoRightText text="因版权限制，暂不支持查看" :tempRoute="tempRoute" v-if="detailOne && detailOne.id && noRight" />
            <div class="news-content">
              <div class="news-intro" ref="contents" v-html="detailOne.content"></div>
            </div>
          </div>`

          <div class="relevance noHover" v-if="detailOne.keywords && detailOne.keywords.length">
            <div class="relavance-title">关键词</div>
            <div class="relavance-content">{{ detailOne.keywords.join('，') }}</div>
          </div>

          <!-- //品牌活动关联 -->
          <div class="relevance" v-if="detailOne.activity_id">
            <div class="relavance-title">关联活动</div>
            <div class="relavance-content" @click="goRelate('activity', detailOne.activity_id)">
              <p>{{ detailOne.activity_name }}</p>
              <span>>></span>
            </div>
          </div>

          <div class="relevance" v-if="detailOne.brand_id">
            <div class="relavance-title">关联品牌</div>
            <div class="relavance-content" @click="goRelate('brand', detailOne.brand_id)">
              <p>{{ detailOne.brand_name }}</p>
              <span>>></span>
            </div>
          </div>
        </div>

        <div class="downFile" v-if="detailOne.attachment">
          <div class="title">附件信息</div>
          <div class="fileList">
            <div class="file-item" @click="downFile(showpath + detailOne.attachment)">
              <!-- -->
              <span class="iconfont icon-folder-download-fill"></span>
              <div class="file-txt">
                <p class="name" :title="detailOne.attachmentname">{{ detailOne.attachmentname }}</p>
                <p class="sub">{{ detailOne.attachmentsize }}MB</p>
                <!-- ，下载次数：1 -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 推荐 -->
      <div class="news-relate" v-if="otherList && otherList.length > 0">
        <div class="title">
          <span>延伸阅读</span>
        </div>
        <div class="relate-list">
          <template v-for="(item, index) in otherList">
            <div class="item" :key="index" @click="goRelateNews(item)" :title="item.title">
              <div class="item-time">
                <span>{{ item.produce_time }}</span>
                <span v-if="item.produce_time && item.author"> / </span>
                <span>{{ item.author }}</span>
              </div>
              <div class="item-title">{{ item.title }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Sbanner from '@/components/sbanner.vue'
import Actions from '../exhibit/components/Actions.vue'
import loading from '@/components/common/loading.vue'
import NoRightText from '@/components/NoRightText.vue'
import colums from '../../colums/colums'
export default {
  components: { Sbanner, Actions, loading, NoRightText },
  name: 'literature-detail',
  props: {},
  data() {
    return {
      id: '',
      showLoading: false,
      otherList: null,
      detailOne: {},
      wxCate: colums.literatureCate,
      authorList: [],
      access: 0,
      noRight: false,
      tempRoute: '',
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted() {
    const { id, access } = this.$route.params
    this.id = id

    if (access) {
      this.access = access.charAt(3)
    }
    this.tempRoute = this.$route.path.replace(/\//g, '-')

    this.getOne()
  },
  methods: {
    async getOne() {
      const params = {
        id: this.id,
        user_id: this.userInfo && this.userInfo.id ? this.userInfo.id : 0,
        ip: window.ip,
        no_access: this.access
      }
      let res = await this.$api.literatureApi.getOneById(params)
      if (res.grant != '已授权') {
        this.noRight = true
      }
      const details = res.data || {}
      const artistlist = res.artistlist || []

      const arr = details.category == 2 ? res.artistlist.filter(v => v.artist_typename != '作者') : res.artistlist
      details.author = this.$utils.fixedHtmlAuthor(arr)

      details.keywords = this.$utils.splitWord(details.keywords);
      details.cover_img = details.cover_img ? res.showpath + details.cover_img : ''
      this.detailOne = details
      this.detailOne.content = this.setContent(this.detailOne.content)

      this.$nextTick(() => {
        this._getOtherList()
        details.category == 2 && this.getAuthor(artistlist.filter(v => v.artist_typename == '作者'))

        const imgs = this.$el.querySelectorAll('img');
        imgs.forEach(img => {
          img.onerror = () => {
            const srcArr = img.src.split('?')
            img.onerror = null
            img.src = srcArr[0]
          };
        });
      })
    },
    compareContent() {
      const _t = this
      this.$nextTick(() => {
        if (_t.authorList && _t.authorList.length) {
          _t.authorList.forEach((v, i) => {
            const body = _t.$refs[`intro_${i}`][0]
            v.showAll = body.clientHeight <= 100
            if (body.clientHeight > 100) {
              v.showAll = false
              v.showBtn = true
            }
          })
        }
      })
    },
    async getAuthor(list) {
      if (list && list.length) {
        let authorList = []
        list.forEach(v => {
          if (v.artist_id) {
            this.$api.artistApi.getOneById({ id: v.artist_id }).then(res => {
              const data = res.data || {}
              const intro = this.$utils.formatAuthorIntro(data, true)
              let arr = [data.isrc == 1 ? `<a class="cl-red" href="/#/artist/${data.id}">${data.name}</a>(著) ` : `${data.name}(著)`]
              intro && arr.push(`${intro}`)
              authorList.push({
                content: arr.join(''),
                showAll: true,
                showBtn: false
              })
              this.authorList = authorList
              this.compareContent()
            })
          }
        })
      }
    },
    async _getOtherList() {
      let params = {
        page: 1,
        pageSize: 5,
        activity_id: this.detailOne.activity_id,
        category: this.detailOne.category
      }
      let res = await this.$api.literatureApi.getList(params)
      const list = res.data || []
      this.otherList = list.filter(v => v.id != this.detailOne.id)
    },

    goRelate(type, id) {
      let path = ''
      if (type == 'activity') {
        path = "/activity/"
      } else {
        path = '/thematic/'
      }
      try {
        let link = this.$router.resolve({
          path: path + id
        })
        window.open(link.href, "_blank")
      } catch (error) {
        this.$router.push({
          path: path + id
        })
      }
    },

    goRelateNews(item) {
      let cateObj = this.wxCate.find(t => { return t.id == item.category })
      let path = cateObj.path
      this.$router.push(path + "/" + item.id)
    },

    downFile(fileSrc) {
      this.addRecord(this.id, 2)
      window.open(fileSrc)
      return;
      let data = [{
        url: fileSrc,
        filename: this.detailOne.attachmentname
      }]
      download.downloadAll(data)

    },
    toLogin() {
      const tempRoute = this.$route.path.replace(/\//g, '-')
      let path = `/login/${tempRoute}`
      this.$router.push(path)
    },
    onShowAll(row) {
      row.showAll = !row.showAll
      this.$forceUpdate()
    },
  },
}
</script>
<style scoped lang="scss">
.news-title {
  position: relative;

  .actionBox {
    position: absolute;
    right: 0;
    top: -40px;
    font-size: 14px;
    font-weight: normal;
  }
}

.news-pub {
  margin-top: 5px;
  margin-bottom: 0;

  &+.news-pub {
    margin-top: 0;
  }

  span {
    &::before {
      content: "/";
      margin: 0 5px;
    }

    &:first-child::before {
      display: none;
    }
  }

  .con {
    padding: 0 10px;
    text-align: center;
  }

  .news-actions {
    position: relative !important;
    width: 255px;

    /deep/ .actions {
      height: 24px;
    }
  }
}

.tags {
  margin-top: 0;
  margin-bottom: 10px;
}

.hideMore {
  height: 100px;
  overflow: hidden;
}
.moreBtn {
  color: #B41717;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  padding-top: 50px;
  position: absolute;
  width: 100%;
  bottom: 0;
  cursor: pointer;
  background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(255, 255, 255, 0)), color-stop(100%, rgba(255, 255, 255, 1)));
  background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 65%, rgba(255, 255, 255, 1) 100%);
  &.close {
    position: relative;
    background-image: none;
    padding-top: 0;
  }
}

.news-content {
  margin-top: 40px;
  position: relative;

}
.noRightFilter {
  margin: 0;
  min-height: 360px;
  &::before {
    content: "";
    height: 100px;
    padding-top: 0;
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 2;
    width: 100%;
    cursor: pointer;
    background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(255, 255, 255, 0)), color-stop(100%, rgba(255, 255, 255, .95)));
    background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .95) 100%);
  }
  &::after {
    top: 150px;
    border-radius: 10px;
  }
  /deep/ .noRightBox {
    top: 150px;
  }
}
</style>